import { BaseComponent } from '../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../../components/Buttons';
import { selectConfig, selectWorks } from '../../../../Api/selectors';
import {
  createVehicleWithProps,
  fromAutotelex,
  initiateVehicleCreate,
  setNewVehicle,
  setNewVehicleValue,
  searchAutotelex,
  applyAutotelexOptionsToVehicle,
} from '../../../actions';
import { REQUEST_VEHICLE } from '../../../constants';
import { selectNewVehicle, selectNewVehicleOptions, selectVehicles } from '../../../selectors';
import { parseVehicle, resetProperties } from '../../../helpers';
import { SelectCreditorModal } from './AddCreditorModal/SelectVehicleCreditorCompany';
import { AddVehicleModalBase } from './VehicleBaseModal/AddVehicleModalBase';
import { fetchCompany, fetchHomeCompany, getCompanyWorkflows } from '../../../../Companies/actions';

import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import { addApiError } from '../../../../Api/actions';
import { CreateTransportOrderModal } from '../../../../TransportOrders/components/createTransportOrder/CreateTransportOrderModal';
import { TransportOrderCreateModal } from '../../../../TransportOrders/components/createTransportOrder';

import { selectHomeCompany } from '../../../../Companies/selectors';

const Container = styled.div`
  .button-add {
    margin-left: auto;
  }
`;

const STATE = {
  isCreditorModal: false,
  isSecondModal: false,
  isTransportOrderModal: false,
  showAcceptDuplicate: false,
  acceptedForDuplicate: false,
  oldVehicles: null,
  step: 1,
};

const INCOMING_TRANSPORT_TYPES = [
  'transport_from_address_id',
  'transport_to_address_id',
  'transport_incoming_from_company_id',
  'transport_incoming_to_company_id',
  'transport_incoming_from_company_name',
  'transport_incoming_to_company_name',
  'transport_direction',
  'transport_is_nl',
  'transport_requested',
];

class VehicleCreateModalsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  handleNext = () => {
    this.setState(prevState => ({
      step: 2,
      isCreditorModal: false,
      isSecondModal: true,
    }));
  };

  handlePrev = () => {
    this.setState(prevState => ({
      step: prevState.step - 1,
      isCreditorModal: true,
      isSecondModal: false,
    }));
  };

  componentDidMount() {
    this.props.init();
    this.props.fetchCompany(4);
  }

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  onCreditorModalConfirm() {
    if (
      this.props.values?.creditor_company &&
      (this.props.values?.creditor || this.props?.serverConfig?.incomingContactOptional)
    ) {
      this.setState({ isCreditorModal: false, isSecondModal: true });
      const companyId = this.props.values?.creditor_company;
      this.props.getCompanyWorkflows(companyId, () => {
        this.setState({ isCreditorModal: false, isSecondModal: true });
      });
    }
  }

  reset() {
    const resetTypes = resetProperties('addModal');
    this.setState({ ...STATE });
    this.props.resetValues(this.propertyNames);
  }

  save(callback, saveStrategy) {
    let properties = [];
    const setIncomingProps =
      this.props.values?.start_incoming_transport == '1' &&
      (this.props.values?.transport == 'pickup' || this.props.values?.transport == 'is_available');

    for (let i in this.props.values) {
      if (i === 'import') {
        properties.push({
          propertyName: i,
          propertyValue: !this.props.values?.regplate?.trim().length ? '1' : this.props.values[i],
        });
      }

      if (i == 'start_incoming_transport_later' && this.props.values[i] == '1') {
        properties.push({
          propertyName: 'incoming_transport_has_to_start',
          propertyValue: '1',
        });
        continue;
      }

      if (INCOMING_TRANSPORT_TYPES.includes(i) && !setIncomingProps) {
        continue;
      }

      if (i === 'wegenbelasting' && this.props?.values[i]?.toLowerCase() == 'onbekend') {
        continue;
      }

      if (i == 'transport_requested') {
        properties.push({
          propertyName: 'transport_requested',
          propertyValue: '1',
        });
        continue;
      }

      if (i == 'transport_direction') {
        properties.push({
          propertyName: 'transport_direction',
          propertyValue: 'incoming',
        });
        continue;
      }

      if (i == 'regplate') {
        properties.push({
          propertyName: 'regplate',
          propertyValue: this.props.values?.[i]?.toUpperCase(),
        });
        continue;
      }

      if ((this.props.values[i] != '' && i !== 'import') || i != 'from_autotelex') {
        properties.push({
          propertyName: i,
          propertyValue: this.props.values[i],
        });
      }
    }

    if (this.props.tradeInVehicle) {
      properties.push({
        propertyName: 'trade_in',
        propertyValue: '1',
      });
    }

    const options = this.state.acceptedForDuplicate ? [{ acceptedForDuplicate: true }] : [];

    const resetTypes = resetProperties('addModal');

    this.props.create(properties, options, result => {
      if (result?.id) {
        this.props.resetValues(['from_autotelex']);
        if (this.props.newVehicleOptions) {
          //the options are not applied from the frontend, the backend re-requests them from autotelex
          this.props.applyNewVehicleOptions(result?.id, this.props.values?.regplate?.trim());
        }
        this.setState({ acceptedForDuplicate: false, oldVehicles: null });

        if (callback) {
          callback(result.id);
          if (saveStrategy == 'quickSave') {
            this.props.resetValues(this.propertyNames);
          }
          if (saveStrategy == 'addAndNew') {
            let resetPropsArr = this.propertyNames.filter(p => p != 'creditor' && p != 'creditor_company');
            this.props.resetValues(resetPropsArr);
          }

          if (saveStrategy == 'saveAndCreateTransportOrder') {
            this.setState({
              vehicle: parseVehicle(result),
              isTransportOrderModal: true,
              isCreditorModal: false,
              isSecondModal: false,
            });
          }
        } else {
          if (this.props.tradeInVehicle) {
            this.setState({ isSecondModal: false });
            this.props.resetValues(this.propertyNames);

            return;
          }
          this.to(`/vehicles/${result.id}/edit/${1}`);
          this.props.resetValues(this.propertyNames);
        }
      }

      if (result?.matchedVehiclesIds && result?.matchedVehiclesIds?.length) {
        this.setState({ showAcceptDuplicate: true, oldVehicles: result?.matchedVehiclesIds });
      }

      if (!result?.id && !result?.matchedVehiclesIds) {
        this.props.addApiError(result?.message);
        this.setState({ isCreditorModal: false, isSecondModal: false });
      }
    });
  }

  confirmDuplicate = callback => {
    this.setState({ acceptedForDuplicate: true, showAcceptDuplicate: false }, () => {
      callback();
    });
  };

  cancelAcceptDuplicate = () => {
    const resetTypes = resetProperties('addModal');
    this.setState(
      { showAcceptDuplicate: false, acceptedForDuplicate: false, oldVehicles: null },
      this.props.resetValues(this.propertyNames),
    );
  };

  acceptDuplicateBody = () => ({
    cancel: () => this.cancelAcceptDuplicate(),
    confirm: callback => this.confirmDuplicate(callback),
    isVisible: this.state.showAcceptDuplicate,
  });

  handleBack = () => {
    let setNewVehicleData = {
      creditor_company: this.props.values.creditor_company,
    };
    if (this.props.values.creditor) {
      setNewVehicleData.creditor = this.props.values.creditor;
    }
    this.props.setNewVehicle(setNewVehicleData, true);
    this.setState(prevState => ({ step: prevState.step - 1, isCreditorModal: true, isSecondModal: false }));
  };

  render() {
    return (
      <>
        {this.state.isCreditorModal && this.state.step === 1 && (
          <SelectCreditorModal
            reset={this.reset.bind(this)}
            onConfirm={this.onCreditorModalConfirm.bind(this)}
            tradeInVehicle={this.props.tradeInVehicle}
            defaultCreditor={this.props.defaultCreditor}
            defaultCreditorUser={this.props.defaultCreditorUser}
            step={this.state.step}
            handleNext={this.handleNext}
          />
        )}
        {this.state.isSecondModal && this.state.step === 2 && (
          <AddVehicleModalBase
            onSave={this.save.bind(this)}
            creditorCompanyId={this.props.values?.creditor_company}
            reset={this.reset.bind(this)}
            acceptCopy={this.acceptDuplicateBody}
            oldVehicles={this.state.oldVehicles}
            tradeInVehicle={this.props.tradeInVehicle}
            back={this.handleBack}
            step={this.state.step}
            handlePrev={this.handlePrev}
          />
        )}
        {this.state.vehicle?.id && this.state.isTransportOrderModal && (
          <TransportOrderCreateModal vehicle={this.state.vehicle} addVehicleModal />
        )}

        {window.innerWidth <= 768 && (
          <ButtonComponent onClick={() => this.setState({ isCreditorModal: true })} style={'ButtonSoftAdd'}>
            {' '}
            +
          </ButtonComponent>
        )}
        {window.innerWidth >= 768 && (
          <>
            <ButtonComponent onClick={() => this.setState({ isCreditorModal: true })} style={'ButtonSoftEdit'}>
              {' '}
              {this.lbl('vehicle.overview.addNewButton')}
            </ButtonComponent>
          </>
        )}
      </>
    );
  }
}

VehicleCreateModalsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
    values: selectNewVehicle(),
    newVehicleOptions: selectNewVehicleOptions(),
    allVehicles: selectVehicles(),
    homeCompany: selectHomeCompany(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateVehicleCreate());
    },
    fetchHomeCompany() {
      dispatch(fetchHomeCompany());
    },
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },

    fetchFromAutotelex(vehicle_id, regplate, callback) {
      dispatch(fromAutotelex(vehicle_id, regplate, callback));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    // fetchCompany(id, callback) {
    //   dispatch(fetchCompany(id, callback));
    // },
    setNewVehicle(data, reset) {
      dispatch(setNewVehicle(data, reset));
    },
    setNewVehicleValue(name, value) {
      dispatch(setNewVehicleValue());
    },
    getCompanyWorkflows(companyId) {
      dispatch(getCompanyWorkflows(companyId));
    },
    applyNewVehicleOptions(vehicleId, regplate, callback) {
      dispatch(applyAutotelexOptionsToVehicle(vehicleId, regplate, callback));
    },
    addApiError(msg) {
      dispatch(addApiError(msg));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateModals = compose(withConnect, withRouter)(VehicleCreateModalsComp);
